import React from "react";

function SvgIcMapPoi027(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.5 11a2.5 2.5 0 012.5 2.5v7.299c0 .378 1.248 2.01 1.248 2.01l3.177 2.039a1.25 1.25 0 01-.675 2.302h-7.5a1.25 1.25 0 010-2.5h3.239s-2.907-1.504-3.238-1.694A2.483 2.483 0 0111 20.799v-7.3a2.5 2.5 0 012.5-2.5zm4-5a2.5 2.5 0 110 5 2.5 2.5 0 010-5z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi027;
